<template>
   <wo-dropdown v-if="hasActions" :mod-right="modRight">
    <wo-link slot="toggle" mod-icon mod-icon-after icon="chevron-down" :mod-subtle="modToggleSubtle">
      <span>{{ toggleLabel }}</span>
    </wo-link>
    <template slot="links">
      <wo-link v-for="(item, index) in items" :key="index" @click.native.prevent="execute(item)"
        :mod-icon="!!item.icon" :mod-icon-before="!!item.icon" :icon="item.icon">{{ item.name }}</wo-link>
    </template>
  </wo-dropdown>
</template>
<script>

import _ from 'lodash'

export default {
  name: 'PoActionDropdown',
  props: {
    actions: Array,
    label: String,
    modRight: Boolean,
    modToggleSubtle: Boolean
  },
  computed: {
    hasActions () {
      return !_.isEmpty(this.actions)
    },
    items () {
      return _.map(this.actions, this.createItem)
    },
    toggleLabel () {
      return this.label ? this.label : this.$t('general.actions')
    }
  },
  methods: {
    createItem (action) {
      return {
        action: action,
        name: action.labelKey ? this.$t(action.labelKey) : action.name,
        icon: action.icon
      }
    },
    execute (item) {
      if (item.action.route) {
        this.$router.push(item.action.route)
      } else if (item.action.execute) {
        item.action.execute()
      } else {
        this.$emit('execute', item.action)
      }
    }
  }
}
</script>
